import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'carbon-components-react';
import ExpandableCard from './ExpandableCard';

class StepCard extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    btnText: PropTypes.string,
    isFinished: PropTypes.bool,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    btnText: 'selecionar',
    isFinished: false,
    disabled: false
  };

  render() {
    const {
      onRef,
      title,
      description,
      btnText,
      isFinished,
      disabled,
      onToggle,
      children,
      optional,
      onButtonClick
    } = this.props;

    return (
      <ExpandableCard
        ref={onRef}
        title={title}
        optional={optional}
        description={description}
        onToggle={onToggle}
        leftComponent={() => (
          <div
            className={`step-card-icon ${
              isFinished ? 'step-card-icon--actived' : ''
            }`}
          >
            <i className="material-icons">
              {!isFinished ? 'check_circle_outline' : 'check_circle'}
            </i>
          </div>
        )}
        rightComponent={() => (
          <Button
            disabled={disabled}
            onClick={onButtonClick}
            className="button h-sm-margin sm-padding"
          >
            {btnText}
          </Button>
        )}
        disabled={disabled}
      >
        {children}
      </ExpandableCard>
    );
  }
}

export default StepCard;



// WEBPACK FOOTER //
// ./src/components/StepCard.js